import type { CandidatesSearch } from './search';

export const candidateKeys = {
  all: ['candidates'] as const,
  lists: () => [...candidateKeys.all, 'list'] as const,
  list: (search: CandidatesSearch) => [...candidateKeys.lists(), search] as const,
  pending: () => [...candidateKeys.lists(), 'pending'] as const,
  flagged: () => [...candidateKeys.lists(), 'flagged'] as const,
  stats: () => [...candidateKeys.all, 'stats'] as const,
  detail: (id: string) => [...candidateKeys.all, 'detail', id] as const,
  snapshot: (id: string, snapshotId: string) =>
    [...candidateKeys.all, 'snapshot', id, snapshotId] as const,
  linkCandidates: (id: string) => [...candidateKeys.all, 'link-candidates', id] as const,
  linkedAll: () => [...candidateKeys.all, 'linked'] as const,
  linked: (eventIds: string[]) => [...candidateKeys.linkedAll(), eventIds] as const,
};
